import React, { useState } from 'react';
import { Outlet, Link, useNavigate, NavLink } from 'react-router-dom';
import { useAdminAuth } from '../../context/AdminAuthContext';

function AdminLayout() {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const { logout } = useAdminAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/admin/login', { replace: true });
  };

  const closeSidebar = () => setSidebarOpen(false);

  return (
    <div className="admin-panel">
      <style>{`
        /* Admin light theme override (applies to all admin pages) */
        .admin-panel{
          background:#f9fafb !important;
          color:#111827 !important;
        }
        .admin-sidebar{
          background:#ffffff !important;
          border-right:1px solid #e5e7eb !important;
        }
        .admin-brand{
          color:#111827 !important;
        }
        .admin-nav-link{
          color:#6b7280 !important;
          background:transparent !important;
        }
        .admin-nav-link:hover{
          background:#f3f4f6 !important;
          color:#111827 !important;
        }
        .admin-nav-link.active{
          background:#e5e7eb !important;
          color:#111827 !important;
        }
        .admin-header{
          background:#ffffff !important;
          border-bottom:1px solid #e5e7eb !important;
          backdrop-filter:none !important;
        }
        .admin-menu-toggle{
          color:#111827 !important;
        }
        .admin-logout-btn{
          border:1px solid rgba(17,24,39,0.15) !important;
          color:#374151 !important;
        }
        .admin-logout-btn:hover{
          background:#f3f4f6 !important;
        }
        .admin-content{
          background:#f9fafb !important;
          color:#111827 !important;
        }
        .admin-dashboard-title,
        .admin-section-title{
          color:#111827 !important;
        }
        .admin-section-description{
          color:#6b7280 !important;
        }
        .admin-dashboard-section,
        .admin-card{
          background:#ffffff !important;
          border:1px solid #e5e7eb !important;
          box-shadow:none !important;
        }
        .admin-video-form-wrap{
          background:#ffffff !important;
          border:1px solid #e5e7eb !important;
          box-shadow:none !important;
        }
        .admin-video-form-title{
          color:#111827 !important;
        }
        .admin-video-form .form-group label{
          color:#6b7280 !important;
        }
        .admin-video-upload-group label{
          color:#6b7280 !important;
        }
        .admin-video-form .form-control{
          background:#ffffff !important;
          border:1px solid #d1d5db !important;
          color:#111827 !important;
        }
        .admin-video-upload-box{
          background:#f9fafb !important;
          border:2px dashed #cbd5e1 !important;
        }
        .admin-auth-submit{
          background:#e5e7eb !important;
          border:1px solid #d1d5db !important;
          color:#111827 !important;
        }
        .admin-auth-submit:not(:disabled):hover{
          background:#d1d5db !important;
        }
        .admin-video-form-close{
          color:#6b7280 !important;
          background:#f3f4f6 !important;
          border:1px solid #e5e7eb !important;
          border-radius:6px !important;
        }
        .admin-video-form-close:hover{
          color:#111827 !important;
          background:#e5e7eb !important;
        }
        .admin-video-cancel-btn{
          background:#f3f4f6 !important;
          border:1px solid #d1d5db !important;
          color:#374151 !important;
        }
        .admin-video-cancel-btn:hover{
          background:#e5e7eb !important;
          color:#111827 !important;
        }
        .admin-confirm-box{
          background:#ffffff !important;
          border:1px solid #e5e7eb !important;
          box-shadow:none !important;
        }
        .admin-confirm-title{
          color:#111827 !important;
        }
        .admin-confirm-text{
          color:#6b7280 !important;
        }
        .admin-confirm-cancel{
          color:#374151 !important;
          border:1px solid #d1d5db !important;
        }
        .admin-confirm-cancel:hover{
          background:#f3f4f6 !important;
          border-color:#cbd5e1 !important;
        }

        /* Dashboard: make all text black */
        .admin-dashboard,
        .admin-dashboard *{
          color:#111827 !important;
        }
        .admin-dashboard a{
          color:#111827 !important;
        }
        .admin-detail-meta{
          color:#2563eb !important; /* blue meta text */
        }

        /* Add video / Add image buttons (shared class) */
        .admin-video-add-toggle-btn{
          background:#f3f4f6 !important;
          border:1px solid #e5e7eb !important;
          color:#374151 !important;
        }
        .admin-video-add-toggle-btn:hover{
          background:#e5e7eb !important;
          color:#111827 !important;
          border-color:#d1d5db !important;
        }

        /* Videos page filter pills */
        .admin-videos-nav-link{
          background:#f3f4f6 !important;
          color:#374151 !important;
          border:1px solid #e5e7eb !important;
        }
        .admin-videos-nav-link:hover{
          background:#e5e7eb !important;
          color:#111827 !important;
        }
        .admin-videos-nav-link.active{
          background:#d1d5db !important;
          color:#111827 !important;
          border-color:#cbd5e1 !important;
        }

        /* Dashboard recent blocks border */
        .admin-dashboard-detail-block{
          border:1px solid #e5e7eb !important;
          background:#ffffff !important;
          border-radius:12px !important;
        }
      `}</style>
      <aside className={`admin-sidebar ${sidebarOpen ? 'admin-sidebar-open' : ''}`}>
        <div className="admin-sidebar-header">
          <Link to="/admin" className="admin-brand" onClick={closeSidebar}>
            Admin Panel
          </Link>
          <button
            type="button"
            className="admin-sidebar-close"
            onClick={closeSidebar}
            aria-label="Close menu"
          >
            <i className="far fa-times" />
          </button>
        </div>
        <nav className="admin-nav">
          <NavLink
            to="/admin"
            className={({ isActive }) => `admin-nav-link ${isActive ? 'active' : ''}`}
            end
            onClick={closeSidebar}
          >
            <i className="far fa-home" /> Dashboard
          </NavLink>
          <NavLink
            to="/admin/gallery"
            className={({ isActive }) => `admin-nav-link ${isActive ? 'active' : ''}`}
            onClick={closeSidebar}
          >
            <i className="far fa-images" /> Gallery
          </NavLink>
          <NavLink
            to="/admin/videos"
            className={({ isActive }) => `admin-nav-link ${isActive ? 'active' : ''}`}
            onClick={closeSidebar}
          >
            <i className="far fa-play-circle" /> Videos
          </NavLink>
          <NavLink
            to="/admin/reviews"
            className={({ isActive }) => `admin-nav-link ${isActive ? 'active' : ''}`}
            onClick={closeSidebar}
          >
            <i className="far fa-star" /> Reviews
          </NavLink>
        </nav>
      </aside>
      <div
        className={`admin-overlay ${sidebarOpen ? 'admin-overlay-visible' : ''}`}
        aria-hidden="true"
        onClick={closeSidebar}
      />
      <div className="admin-main">
        <header className="admin-header">
          <button
            type="button"
            className="admin-menu-toggle"
            onClick={() => setSidebarOpen(true)}
            aria-label="Open menu"
          >
            <i className="far fa-bars" />
          </button>
          <div className="admin-header-right">
            <button
              type="button"
              className="admin-logout-btn"
              onClick={handleLogout}
            >
              <i className="far fa-sign-out-alt" /> Logout
            </button>
          </div>
        </header>
        <main className="admin-content">
          <Outlet />
        </main>
      </div>
    </div>
  );
}

export default AdminLayout;
